/**
 * ArchiMate SVG Icon System
 * Маппинг на реальные файлы иконок
 */

const ICON_BASE_PATH = '/images/archimate';

// Маппинг типов элементов на файлы иконок
export const ARCHIMATE_ICON_MAP = {
  // Strategy Layer
  'resource': 'strategy-resource.svg',
  'capability': 'strategy-capability.svg',
  'course_of_action': 'strategy-courseofaction.svg',
  'value_stream': 'strategy-valuestream.svg',

  // Business Layer
  'business_actor': 'business-actor.svg',
  'business_role': 'business-role.svg',
  'business_collaboration': 'business-collaboration.svg',
  'business_interface': 'business-interface.svg',
  'business_process': 'business-process.svg',
  'business_function': 'business-function.svg',
  'business_interaction': 'business-interaction.svg',
  'business_event': 'business-event.svg',
  'business_service': 'business-service.svg',
  'business_object': 'business-object.svg',
  'contract': 'business-contract.svg',
  'representation': 'business-representation.svg',
  'product': 'business-product.svg',

  // Application Layer
  'application_component': 'application-component.svg',
  'application_collaboration': 'application-collaboration.svg',
  'application_interface': 'application-interface.svg',
  'application_function': 'application-function.svg',
  'application_interaction': 'application-interaction.svg',
  'application_process': 'application-process.svg',
  'application_event': 'application-event.svg',
  'application_service': 'application-service.svg',
  'data_object': 'application-dataobject.svg',

  // Technology Layer
  'node': 'technology-node.svg',
  'device': 'technology-device.svg',
  'system_software': 'technology-systemsoftware.svg',
  'technology_collaboration': 'technology-collaboration.svg',
  'technology_interface': 'technology-interface.svg',
  'technology_function': 'technology-function.svg',
  'technology_process': 'technology-process.svg',
  'technology_service': 'technology-service.svg',
  'artifact': 'technology-artifact.svg',

  // Physical Layer
  'equipment': 'technology-equipment.svg',
  'facility': 'technology-facility.svg',
  'material': 'technology-material.svg',

  // Implementation Layer
  'work_package': 'implementation-workpackage.svg',
  'deliverable': 'implementation-deliverable.svg',
  'plateau': 'implementation-plateau.svg',
  'gap': 'implementation-gap.svg',

  // Motivation Layer
  'stakeholder': 'motivation-stakeholder.svg',
  'driver': 'motivation-driver.svg',
  'assessment': 'motivation-assessment.svg',
  'goal': 'motivation-goal.svg',
  'outcome': 'motivation-outcome.svg',
  'principle': 'motivation-principle.svg',
  'requirement': 'motivation-requirement.svg',
  'constraint': 'motivation-constraint.svg',
  'value': 'motivation-value.svg'
};

/**
 * Получить путь к иконке для типа элемента
 */
export const getArchimateIconPath = (elementType) => {
  const iconFile = ARCHIMATE_ICON_MAP[elementType];
  return iconFile ? `${ICON_BASE_PATH}/${iconFile}` : null;
};

/**
 * Проверить, существует ли иконка для типа
 */
export const hasArchimateIcon = (elementType) => {
  return !!ARCHIMATE_ICON_MAP[elementType];
};
